module.exports = __webpack_public_path__ + "static/media/sample_3-03.2079a39c.jpg";